module.exports = __webpack_public_path__ + "img/UI_yqrmyx_bg_1eec4fdff.png";